export const Navigation = [
  {
    id: 1,
    href: "rail",
    name: "Introduction"
  },
  {
    id: 2,
    href: "tram",
    name: "Sky PRT Smart Tram"
  },
  // {
  //   id: 3,
  //   href: "system",
  //   name: "Smart freight system"
  // },
  // {
  //   id: 4,
  //   href: "market",
  //   name: "Market Analysis and Trend"
  // }
]